import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { lifecycle, compose } from 'recompose';
import { connect } from 'react-redux';
import { getProfile } from '../../Redux/user-profile/actions';

const doValidate = lifecycle({
  componentDidMount() {
    const { error } = this.props;
    if (error && error.message) {
      const errorMessage = error.message || '';
      if (errorMessage.indexOf('401: Unauthorized') >= 0) {
        this.props.getProfile();
      }
    }
  },
});

const ErrorHandleView = () => <div />;
const UserErrorHandling = compose(connect(null, { getProfile }), doValidate)(ErrorHandleView);

export default UserErrorHandling;
